import { useNavigate, useStore, usePathValidation } from '~hooks'
import { Input, Title, Subtitle, SubmitButton, Typography } from '~components'
import { Values } from './interfaces'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { string, object } from '~utils/validation'
import { KeyboardEvent, useEffect, ClipboardEvent } from 'react'
import { track } from '@amplitude/analytics-browser'

function FullName() {
  const navigate = useNavigate()
  const { register: registerStore, update } = useStore()
  const nameRegularExpression =
    /^(([a-zà-ÿA-ZÀ-Ÿ]{2,}){1}(\s([a-zà-ÿA-ZÀ-Ÿ]{1,}))+)\s*$/im
  const defaultValues = { fullName: registerStore?.fullName || '' }
  const schema = object().shape({
    fullName: string()
      .min(4, '')
      .max(120, '')
      .matches(nameRegularExpression, '')
      .required(''),
  })
  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    track('cadastro_nome')
  }, [])
  useEffect(() => {
    update({ register: { progress: 10 } })
  }, [update])
  usePathValidation(['cpf', 'register.cellphone'])

  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement
    const emptySpace = ' '
    const isFirstSpaceEmpty = !target.value.length && event.key === emptySpace
    const isPressingEmptySpace =
      target.value[target.value.length - 1] === emptySpace && event.key === emptySpace
    if (isFirstSpaceEmpty || isPressingEmptySpace) {
      event.preventDefault()
    }
  }
  function handlePaste(event: ClipboardEvent<HTMLInputElement>) {
    const paste = event.clipboardData.getData('text')
    const hasNumbersOnPastedValue = !/[^a-zà-ÿ÷ ]+/gi.test(paste)
    const hasWrongSpaces = paste.trim() !== paste

    if (hasNumbersOnPastedValue || hasWrongSpaces) {
      event.preventDefault()
    }
  }
  function handleInput(event: React.KeyboardEvent<HTMLInputElement>) {
    const target = event.nativeEvent.target as HTMLInputElement
    target.value = target.value.replace(/[^a-zà-ÿ`~´^¨ ]|÷+/gi, '')
  }
  function onSubmit(values: Values) {
    update({ register: values })
    navigate('/cadastrar/placa', { state: { previousPath: '/cadastrar/nome-completo' } })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-full-name-title">
      <Title id="form-full-name-title">Digite o seu nome completo</Title>
      <Subtitle>Ele deve estar igual no seu RG.</Subtitle>
      <Typography as="label">Nome completo</Typography>
      <Input
        name="fullName"
        data-testid="fullName"
        register={register}
        onPaste={handlePaste}
        onKeyDown={handleKeyDown}
        maxLength={120}
        onInput={handleInput}
        autoFocus
      />
      <SubmitButton width="100%" disabled={!isValid}>
        Continuar
      </SubmitButton>
    </form>
  )
}

export default FullName
